import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DsjStoreName } from "../Constants";
import { mapProvinceOfResidency } from "../../api/mappers";
import { NUMBER_OF_QUESTIONS } from "../../components/CEF/Common/Constants";
import { StoredPreferences } from "../../components/StudentOnboarding/storage/StoredPreferences";
var initializeState = function initializeState() {
  return {};
};
export var loadState = function loadState() {
  try {
    var serializedState = localStorage.getItem(DsjStoreName);
    if (!serializedState) return initializeState();
    var state = JSON.parse(serializedState);
    return state;
  } catch (error) {
    console.error(error);
    return initializeState();
  }
};
export var saveState = function saveState(state) {
  try {
    var _state$CefApplication, _application$national, _application$countryO, _application$stateOfR;
    var mappedState = state;
    var application = state === null || state === void 0 ? void 0 : (_state$CefApplication = state.CefApplication) === null || _state$CefApplication === void 0 ? void 0 : _state$CefApplication.application;
    var mappedProvinceOfResidency = mapProvinceOfResidency(application === null || application === void 0 ? void 0 : (_application$national = application.nationality) === null || _application$national === void 0 ? void 0 : _application$national.code, application === null || application === void 0 ? void 0 : (_application$countryO = application.countryOfResidence) === null || _application$countryO === void 0 ? void 0 : _application$countryO.code, application === null || application === void 0 ? void 0 : (_application$stateOfR = application.stateOfResidence) === null || _application$stateOfR === void 0 ? void 0 : _application$stateOfR.code);
    if (application && mappedProvinceOfResidency) {
      var _state$CefApplication2, _state$CefApplication3;
      mappedState = _objectSpread(_objectSpread({}, state), {}, {
        CefApplication: _objectSpread(_objectSpread({}, state.CefApplication), {}, {
          applicationCompleteOnLoad: !!((state === null || state === void 0 ? void 0 : (_state$CefApplication2 = state.CefApplication) === null || _state$CefApplication2 === void 0 ? void 0 : (_state$CefApplication3 = _state$CefApplication2.validKeys) === null || _state$CefApplication3 === void 0 ? void 0 : _state$CefApplication3.length) === NUMBER_OF_QUESTIONS),
          application: _objectSpread(_objectSpread({}, state.CefApplication.application), {}, {
            stateOfResidence: {
              code: mappedProvinceOfResidency,
              name: mappedProvinceOfResidency
            }
          })
        })
      });
    }
    var serializedState = JSON.stringify(mappedState);
    localStorage.setItem(DsjStoreName, serializedState);
  } catch (error) {
    console.error(error);
  }
};
export var deleteState = function deleteState() {
  try {
    localStorage.removeItem(DsjStoreName);
    StoredPreferences.deleteAll();
  } catch (error) {
    console.error(error);
  }
};